import axiosClient from 'utils/axiosClient';
import api from 'api';

const getPassengers = async (data?: any) => {
	const response = await axiosClient.get(api.PRIVATE.GET_PASSENGER, {params: data});
	return response.data;
};

const deletePassenger = async (id: string) => {
	const response = await axiosClient.delete(api.PRIVATE.DELETE_PASSENGER + id);
	return response.data;
};

const updatePassenger = async (data: any, id: string) => {
	const response = await axiosClient.patch(api.PRIVATE.UPDATE_PASSENGER + id, data);
	return response.data;
};
const service = {
	getPassengers,
	deletePassenger,
	updatePassenger
};

export default service;
